app.controller('countyListController', function ($scope, $timeout) {

  $scope.expandedCadCode = null
  $scope.selectedCounty = null

  const PORTAL_ACCESS_FIELD_LABELS = {
    agent_id: 'Agent ID',
    portal: 'Portal',
    portal_url: 'Portal URL',
    secondary_portal: 'Secondary Portal',
    login: 'Login',
    password: 'Password',
    aoa_submission: 'AoA Submission'
  }
  const PORTAL_ACCESS_FIELD_ORDER = [
    'agent_id', 'login', 'password', 'portal', 'portal_url', 'secondary_portal', 'aoa_submission'
  ]

  $scope.getPortalEntries = (portalAccess) => {
    if (!portalAccess || typeof portalAccess !== 'object') return []
    return Object.keys(portalAccess).map((entityKey) => {
      const entityData = portalAccess[entityKey] || {}
      const fieldKeys = Object.keys(entityData)
      fieldKeys.sort((a, b) => {
        const ai = PORTAL_ACCESS_FIELD_ORDER.indexOf(a)
        const bi = PORTAL_ACCESS_FIELD_ORDER.indexOf(b)
        if (ai === -1 && bi === -1) return a.localeCompare(b)
        if (ai === -1) return 1
        if (bi === -1) return -1
        return ai - bi
      })
      return {
        entity: entityKey,
        fields: fieldKeys.map((k) => ({
          key: k,
          label: PORTAL_ACCESS_FIELD_LABELS[k] || k,
          value: entityData[k]
        }))
      }
    })
  }

  $scope.isUrlLike = (value) => {
    if (!value || typeof value !== 'string') return false
    const v = value.trim()
    if (/^https?:\/\//i.test(v)) return true
    return /^[a-z0-9-]+(\.[a-z0-9-]+)+(\/.*)?$/i.test(v)
  }

  $scope.buildUrl = (value) => {
    if (!value) return ''
    return /^https?:\/\//i.test(value) ? value : 'http://' + value
  }

  $scope.openUrl = (value) => {
    const url = $scope.buildUrl(value)
    if (url) window.open(url, '_blank', 'noopener')
  }

  $scope.copyToClipboard = (value) => {
    if (value === null || value === undefined) return
    const text = String(value)
    if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text)
    } else {
      const tempInput = document.createElement('input')
      tempInput.value = text
      document.body.appendChild(tempInput)
      tempInput.select()
      document.execCommand('copy')
      document.body.removeChild(tempInput)
    }
  }

  $scope.onCountySelected = (county) => {
    if (!county || !county.cad_code) return
    $scope.selectedCounty = county
    $scope.expandedCadCode = county.cad_code
    $timeout(() => {
      const el = document.getElementById(`county-card-${county.cad_code}`)
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'center' })
      }
    }, 0)
  }

  $scope.onCardClick = (county) => {
    if ($scope.expandedCadCode === county.cad_code) {
      $scope.expandedCadCode = null
      $scope.selectedCounty = null
    } else {
      $scope.expandedCadCode = county.cad_code
      $scope.selectedCounty = county
    }
  }

})
